import Base from '../BaseContainer'

class BaseLibraryContainer extends Base {

  constructor () {
    super()
    this._bind('_handleRemoveFile', '_handleFileDrop', '_handleCancelFileDrop', '_handleReplace', '_handleUploadMedias', '_handleDownloadAllMedias')
  }

  componentDidUpdate () {
    this._onUpdate()
  }

  _onUpdate () {
    if (this.props.uploadState === 'SUCCESS') {
      this.props.reinitUploader()
      this.setState({ droppedFiles: [] })
    }
  }

  _handleRemoveFile (mediaId) {
    if (mediaId) {
      this.props.deleteFile(this.props.app.id, parseInt(mediaId, 0))
    }
  }
  _handleCancelFileDrop () {
    this.setState({ openedSizeAlert: false })
  }
  _handleFileDrop (files) {
    console.log("files");
    console.log(files);
    let size = 0
    for (let i = 0; i < files.length; i++) {
      size += files[i].size
    }
    if (size <= 2e+6) {
      this.setState({ droppedFiles: files })
      let dropArea = document.querySelector('#uploaderFullsized')
      if (dropArea) {
        dropArea.style.display = 'none'
        document.querySelector('#LibraryHeader').classList.remove('blur')
        document.querySelector('#ScrollLibrary').classList.remove('blur')
      }
      this.props.upload(files, this.props.app.id)
    } else {
      this.setState({ openedSizeAlert: true })
    }
  }
  _handleReplace (fileId, file) {
    // console.log(fileId, file)
    if (file && fileId) {
      if (file.size <= 2e+6) {
        // console.log('ready to go')
        this.props.replaceFile(this.props.app.id, fileId, file)
      } else {
        this.setState({ openedSizeAlert: true })
      }
    }
  }
  _handleUploadMedias (file) {
    this.props.uploadMedias(this.props.app.id, file);
  }
  _handleDownloadAllMedias () {
    this.props.downloadAllMedias(this.props.app.id);
  }
}

export default BaseLibraryContainer
